<template>
  <div v-if="renderReady && !model.$disabled && showLabel">
    <label v-if="getTitle || hasDefaultSlot" :for="labelFor" class="label">
      <w-next-number v-bind="nextNumber" v-if="nextNumber" />

      <span :class="boldLabel ? 'text-bold' : ''">
        <slot>{{ getTitle }}</slot>&nbsp;
      </span>

      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{ tooltipContent }}</w-tooltip>

      <w-description :model="model" v-bind="description">
        <slot name="description" />
      </w-description>
    </label>

    <slot name="afterLabel" />
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';
import titleMixin from '../mixins/titleMixin';
import WTooltip from './tooltip.vue';

export default {
  name: 'w-label',
  components: {WTooltip},
  props: {
    css: [Object, String, Array]
  },
  mixins: [modelMixin, titleMixin],
  computed: {
    hasDefaultSlot() {
      //TODO: has any not empty slot
      return this.$slots && this.$slots.default;
    }
  }
};
</script>

<style scoped>
.smart-form label.label {
  display: inline-block;
}
</style>